import React, { useEffect, useState } from "react";
import { Routes, Route, Link, NavLink } from "react-router-dom";
import Home from "./components/Home";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";
import Footer from "./components/Footer";

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.className = darkMode ? "dark" : "light";
  }, [darkMode]);

  return (
    <>
      {/* Inline CSS */}
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: "Segoe UI", sans-serif;
        }

        body.light {
          background: #f8fafc;
          color: #0f172a;
        }

        body.dark {
          background: #0f172a;
          color: #e5e7eb;
        }

        .site-header {
          position: sticky;
          top: 0;
          z-index: 1000;
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        body.dark .site-header {
          background: rgba(15, 23, 42, 0.85);
        }

        .site-header.scrolled {
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }

        .container {
          max-width: 1200px;
          margin: auto;
          padding: 16px 24px;
        }

        .header-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .brand {
          display: flex;
          align-items: center;
          gap: 12px;
          text-decoration: none;
          color: inherit;
        }

        .logo {
          font-size: 34px;
          animation: bounce 2s infinite;
        }

        @keyframes bounce {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }

        .brand-text h1 {
          font-size: 22px;
        }

        .tag {
          font-size: 12px;
          opacity: 0.7;
        }

        .main-nav {
          display: flex;
          align-items: center;
          gap: 18px;
        }

        .main-nav a {
          text-decoration: none;
          color: inherit;
          font-weight: 500;
          position: relative;
        }

        .main-nav a.active::after {
          content: "";
          position: absolute;
          bottom: -6px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #22c55e;
        }

        .cta {
          background: #22c55e;
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          transition: transform 0.2s ease;
        }

        .cta:hover {
          transform: scale(1.05);
        }

        .theme-toggle {
          background: none;
          border: none;
          font-size: 18px;
          cursor: pointer;
        }

        main {
          min-height: 80vh;
          padding: 40px 20px;
          animation: fadeIn 0.5s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .main-nav {
            gap: 12px;
          }

          .brand-text h1 {
            font-size: 18px;
          }
        }
      `}</style>

      <div className="app-root">
        <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
          <div className="container header-inner">
            <Link to="/" className="brand">
              <div className="logo">🏸</div>
              <div className="brand-text">
                <h1>Sportyfo</h1>
                <p className="tag">Play • Track • Improve</p>
              </div>
            </Link>

            <nav className="main-nav">
              <NavLink to="/" end>Home</NavLink>
              <NavLink to="/privacy">Privacy</NavLink>
              <NavLink to="/terms">Terms</NavLink>
              <a href="mailto:sportyfo.official@gmail.com" className="cta">Contact</a>
              <button
                className="theme-toggle"
                onClick={() => setDarkMode(!darkMode)}
              >
                {darkMode ? "☀️" : "🌙"}
              </button>
            </nav>
          </div>
        </header>

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </>
  );
}

export default App;
